import moment from 'moment';
import _ from 'lodash';
import StripHtmlFilter from 'utils/lsp-filters/strip-html-filter';

const stripHtmlFilter = new StripHtmlFilter();

function subscriptions2Object(subscriptions = []) {
  return subscriptions.reduce((reduced, item) => {
    const category = reduced[item.smsCategoryTxt] || {
      name: item.smsCategoryTxt,
      id: item.smsCategoryId,
      subscriptions: {},
    };
    category.subscriptions[item.smsTypeTxt] = {
      name: item.smsTypeTxt,
      id: item.smsTypeId,
      sendSms: item.sendSms,
    };
    reduced[item.smsCategoryTxt] = category;
    return reduced;
  }, {});
}

function subscriptions2Array(categories = {}) {
  return Object.keys(categories).reduce(
    (reduced, categoryId) =>
      Object.keys(categories[categoryId].subscriptions).reduce(
        ((category, innerReduced, subscriptionId) => {
          const subscription = category.subscriptions[subscriptionId];
          return innerReduced.concat([
            {
              smsTypeCategory: `${category.id}.${subscription.id}`,
              smsCategoryId: category.id,
              smsCategoryTxt: category.name,
              smsTypeId: subscription.id,
              smsTypeTxt: subscription.name,
              sendSms: subscription.sendSms,
            },
          ]);
        }).bind(null, categories[categoryId]),
        reduced
      ),
    []
  );
}

function transformSmsTemplate4Multilang(smsTypes, template = {}) {
  return Object.keys(template.smsTemplateTranslations).reduce((reduced, item, index) => {
    const langObj = template.smsTemplateTranslations[index];
    const smsTemplateDisplayName = smsTypes.filter((item) => item.smsTypeName === template.smsTemplateName);

    reduced[langObj.locale] = {
      smsTemplateId: template.smsTemplateId,
      smsTemplateName: template.smsTemplateName,
      smsTemplateDisplayName: _.get(smsTemplateDisplayName, '0.smsTypeTxt') || template.smsTemplateName,
      smsTemplateBodyTxt: langObj.smsTemplateBodyTxt,
    };
    return reduced;
  }, {});
}

function transformMultilangTemplate4Save(deps, multilangTemplate = {}) {
  return Object.keys(multilangTemplate).reduce(
    (reduced, langKey) => {
      const langObj = multilangTemplate[langKey];
      reduced.smsTemplateId = langObj.smsTemplateId;
      reduced.smsTemplateName = langObj.smsTemplateName;
      reduced.smsTemplateTranslations = reduced.smsTemplateTranslations.concat([
        {
          smsTemplateBodyTxt: _.truncate(
            _.trim(stripHtmlFilter(langObj.smsTemplateBodyTxt)),
            {
              length: deps.config.smsNotificationPopupMaxCharCount,
              omission: '',
            }
          ),
          locale: langKey,
        },
      ]);
      return reduced;
    },
    {
      smsTemplateId: -1,
      smsTemplateName: '',
      smsTemplateTranslations: [],
    }
  );
}

function timezoneDiffTMilliseconds(timezoneDiff) {
  return ((timezoneDiff * 1)/100)*3600*1000;
}

export default {
  subscriptions2Object,
  subscriptions2Array,
  transformSmsTemplate4Multilang,
  transformMultilangTemplate4Save,
};



// WEBPACK FOOTER //
// ./src/modules/sms/helpers/sms-helpers.js